export const hasFlag = <T extends number>(mask: number | undefined, flag: T): boolean => {
  if (!mask) {
    return false
  }
  return (mask & flag) === flag
}
